var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCorreo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 40.6",
    style: {
      enableBackground: "new 0 0 46 40.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.4,10.7 0.4,33.1 13.8,21.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,3.8H3.9c-1.8,0-3.2,1.3-3.5,3l17.8,14.8l3,2.5c1,0.8,2.6,0.8,3.7,0l3.1-2.6L45.6,6.8 C45.3,5.1,43.8,3.8,42,3.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.6,33.1 45.6,10.7 32.2,21.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,26l-2.4,2c-1,0.8-2.6,0.8-3.7,0l-3.1-2.6l-1.8-1.5L1.7,36c0.6,0.5,1.4,0.8,2.2,0.8H42 c0.8,0,1.6-0.3,2.2-0.8L29.7,23.9L27.2,26z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorreo);
export default __webpack_public_path__ + "static/media/icon-correo.f41b744ca7611c10238f9bc7ebc007b8.svg";
export { ForwardRef as ReactComponent };